module.exports = __webpack_public_path__ + "img/icon-login.6b4d42a6.svg";